import React from 'react'
import { Alert, Typography, Box } from '@mui/material';
import DialogComponent from '../../../common/components/DialogComponent';
import ProgressOverlay from '../../../common/components/ProgressOverlay';


const CustComplianceSummaryModal = ({open, onClose, loading, data, error}) => {
   return (
    <DialogComponent open={open} onClose={onClose} title="Conversation Summary" setWidth="md">
      {loading ? (
        <ProgressOverlay />
      ) : error ? (
        <Alert severity="error">{error}</Alert>
      ) : !data || data.length === 0 ? (
        <Alert severity="info">No compliance records found for this conversation.</Alert>
      ) : (
        <Box>
          {data.map((row, idx) => (
            <Box key={idx} sx={{ mb: 2 }}>
              <Typography variant="body2">{row.comments}</Typography>
            </Box>
          ))}
        </Box>
      )}
    </DialogComponent>
  );
}

export default CustComplianceSummaryModal